<template>
  <ion-page id="welcome-page">
    <ion-content ref="content" >
      <ion-item id="home">
      </ion-item>
      <ion-item>
          <ion-img class="chess-image" src="assets/png/chess_square_400.png" alt="Chessvis"></ion-img>
     </ion-item>
     <ion-item >
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-item color="primary">
            <ion-label class="text-center">
              <h1>{{ t("Chessvis can make you a better chess player") }}</h1>
            </ion-label>
          </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-label class="text-center">
              <h2><i>{{ t("Put it's unique puzzle visualization, opening preparation and blindfold play tools to work for you here: Right Now! on the web or in the native apps") }}: </i>
              <ion-button class="button-center" size="small" color="secondary" 
                      @click="getMobileVersion('google')" >
              <ion-icon  :icon="googleIcon" ></ion-icon>Google Play
            </ion-button>
            <ion-button class="button-center" size="small" color="secondary" 
                      @click="getMobileVersion('ios')" >
              <ion-icon  :icon="appleIcon" ></ion-icon>App Store
            </ion-button>
            </h2>
            </ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>

    <ion-item id="puzzles" color="primary">
      <h1>{{ t("Puzzles") }}</h1>
    </ion-item>
      <ion-item>
          <ion-img class="puzzle-screenshot" src="assets/png/chessvis_v9_puzzle_visualization_screenshot.png" alt="Chessvis"></ion-img>
     </ion-item>
     <ion-item>
      {{ t("The Chessvis puzzle collection starts with the over 4.5 million categorized and rated puzzles from Lichess and adds several unique features including:") }}
      </ion-item>
      <ion-item>
      <ion-label>
        <h1>{{ t("Category and Rating Control") }}</h1>
        <p>{{ t("Chessvis lets you set both the category and rating of the puzzles you’re challenged with. Want to try easy forks one day and hard multiple move mates the next? Do it! You’ll never be forced to only do puzzles around some hypothetical rating you’ve 'earned'. The entire puzzle collection is always available for you.") }}</p>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label>
        <h1>{{ t("Visualized Puzzles") }}</h1>
        <p>{{ t("A unique feature of Chessvis is the 'Visualized' puzzle. It presents a puzzle showing the diagram from some number of moves before the actual tactic sequence starts. You're told the number of moves to 'visualize' and then solve the problem from a board position that only exists in your mind. This is what got Chessvis started and it’s the only app with it.<i>(There's a short video showing the power of this technique. You'll find it on the right side menu.</i>)") }}</p>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label>
        <h1>{{ t("Other Puzzle Collection Features") }}</h1>
        <p>{{ t("The 'no repeat pledge' - with such an extensive puzzle collection, Chessvis is able to make sure you don’t see the same puzzle twice. Want to focus on solving puzzles quickly? Turn on the timer. Going to be away from the internet? Pull two thousand puzzles down to your device and work off-line. See your puzzle history. Download the puzzles you’ve done. Graph the results. Compare with others. All that is in Chessvis.") }}</p>
      </ion-label>
    </ion-item>
      
  
    
<ion-item id="opening" color="primary">
<h1>{{ t("Opening Mastery") }}</h1>  
</ion-item>
<ion-item>
  <ion-img class="opening-screenshot" src="assets/png/chessvis_v9_opening_explorer.png" alt="Chessvis"></ion-img>
     </ion-item>
     <ion-item>
      {{ t("A radically new, data driven approach to chess openings! Watch one of the 'Opening' videos to see it in action and how it can maximize your opening preparation time.") }}
      </ion-item>

      <ion-item>
    <ion-label>
        <h1>{{ t("Focus on the moves you'll see") }}</h1>
        <p>{{ t("Track a sequence of moves and then update the board to that point. Follow a game from the beginning, some random location within a game or specify the number of pieces you want to follow.") }}"</p>
        <ul>
                <li><b>{{ t("Move percentages") }}</b> - {{ t("Concentrate your study time on the moves that you'll actually see and not complex long move sequences that will rarely appear.") }}</li>
                <li><b>{{ t("Unique Head-to-Head Game Collection") }}</b> - {{ t("Only games where both players are in the same 50 point rating bracket are included. Why? Because even a 50 point rating difference skews the results.") }}</li>
                <li><b>{{ t("over 200+ Million games") }}</b> - {{ t("Only the Lichess 'Rapid' games with their longer time control are used. You get millions of games per rating bracket but at the same time get games where more thought was given.") }}</li>
                <li><b>{{ t("Concentrate on the games of your peers") }}</b> - {{ t("Filter the games down to your rating. Different rated players make different moves. And while 'studying the masters' is a nice theory, in reality they don't play like us.") }}"</li>
              </ul>
      </ion-label>
    </ion-item>

    <ion-item>
    <ion-label>
        <h1>{{ t("Focus on the moves that work!") }}</h1>
        <p>{{ t("Track a sequence of moves and then update the board to that point. Follow a game from the beginning, some random location within a game or specify the number of pieces you want to follow.") }}"</p>

        <ul>
                <li><b>{{ t("Compare Move Choices") }}</b> - {{ t("Chess Opening Mastery can display any number of move choices side by side in the graph.") }}</li>
                <li><b>{{ t("See into the Middle Game") }}</b> - {{ t("This is the only program in the world that shows the impact of opening moves on the middle game.") }}</li>
                <li><b>{{ t("Move Beyond Win/Loss percentages") }}</b> - {{ t("Why are we still picking first moves based on the way games end 40 or 60 moves later? That's an unfair burden to place on the first move.") }}</li>
                <li><b>{{ t("Avoid Traps") }}</b> - {{ t("With the program's focus on how games are doing in the middle game, your opponent's trappy openings show themselves quickly and show you how to easily avoid them.") }}</li>
              
              </ul>
      </ion-label>
    </ion-item>


<ion-item id="visualize" color="primary">
<h1>{{ t("Visualization Tools") }}</h1>
</ion-item>
<ion-item>
  <ion-img class="chess-image" src="assets/png/chessvis_v9_who_guarding.png" alt="Chessvis"></ion-img>
     </ion-item>
     <ion-item>
      {{ t("Chessvis started as a 'visualization' app. (That is the source of the 'vis' in the name.) Yes, it has grown, but it has never forgotten the importance of visualization in helping a player get better.") }}</ion-item>
      <ion-item>
      <ion-label>
        <h1>{{ t("Who’s Guarding Whom") }}</h1>
        <p>{{ t("A deceptively simple visualization exercise that forces you to mentally track piece movements and how they interact. (No other app has this.) The 'Video' section on the right side menu has a short video on it.") }}</p>
      </ion-label>
    </ion-item>

    <ion-item>
    <ion-label>
        <h1>{{ t("Move Following") }}</h1>
        <p>{{ t("Track a sequence of moves and then update the board to that point. Follow a game from the beginning, some random location within a game or specify the number of pieces you want to follow.") }}</p>
      </ion-label>
    </ion-item>

    <ion-item>
    <ion-label>
        <h1>{{ t("Static Boards") }}</h1>
        <p>{{ t("What could be simpler than this? You look at and memorize a board layout, then recreate it. Start off easy with just a few pieces and work your way up.") }}</p>
      </ion-label>
    </ion-item>

<ion-item id="blindfold" color="primary">
<h1>{{ t("Blindfold Chess") }}</h1>  
</ion-item>

<ion-item>
  <ion-img class="chess-image" src="assets/jpg/blindfold_square.jpg" alt="Chessvis"></ion-img>
     </ion-item>
     <ion-item>
      {{ t("Play against the computer with 'stepping stones' to help you ease your way into blindfold chess.") }} 
      </ion-item>
      <ion-item>
      <ion-label>
        <h1>{{ t("Stepping Stones") }}</h1>
        <p>{{ t("Start with all pieces sharing one color then go to two color disks, one shared color disk and then eventually an empty board.") }}</p>
      </ion-label>
    </ion-item>

    <ion-item>
    <ion-label>
        <h1>{{ t("Reveal") }}</h1>
        <p>{{ t("Reveal the board when you feel the need or automatically every # of moves to check on your visualization.") }}</p>
      </ion-label>
    </ion-item>

    <ion-item>
    <ion-label>
        <h1>{{ t("How about Voice Controlled Blindfold Chess??") }}</h1>
        <p>{{ t("Looking for a blindfold chess game where you can speak your moves and hear the opponent's? Check out my other app - Verbal Chess. You'll find a link to its 'Landing' page under right hand's 'Support' menu") }}</p>
      </ion-label>
    </ion-item>

    <ion-item>
    <ion-label>
        <ion-button color="success" size="medium" @click="displayTOS()" >{{ t("See The Terms &amp; Privacy Statement") }}</ion-button>
      </ion-label>
    </ion-item>

        <!-- <iframe :src="url" :style="styleOneFrame" :key="menuTrigger"></iframe> -->
    </ion-content>
    <Toolbar id="the_toolbar" :ignoreClicks="showTour" 
                  :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
   </ion-page>
  </template>
  
  <script setup>
  
  import { IonLabel,IonButton,IonIcon,IonGrid,IonRow,IonCol,IonImg,IonItem,IonPage, 
                  IonContent ,modalController} from '@ionic/vue';
  
  import { logoApple, logoAppleAppstore,logoGooglePlaystore } from 'ionicons/icons';
  import Toolbar from '@/components/Toolbar.vue'

  import ModalTOS from '@/components/ModalTOS.vue'

  import { ref, watch, onMounted } from 'vue'
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  
  import { availableWidthHeight } from '@/composables/screenSize'
  import { t } from '@/composables/translateText.js'

  const emit = defineEmits(['menu-item-click'])

  const appleIcon = ref(logoApple)
  const googleIcon = ref(logoGooglePlaystore)

  const connectionStore = useConnectionStore()
    
  const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")
  
  const urlBase = "https://www.chessvis.com/landing_page_embedded/index_embedded.html"
  const url = ref(urlBase)
  const showTour = ref(false)

  const menuTrigger = ref(0)
  const toolbarTrigger = ref(0)

  const TOOLBAR_HOME = 0
  const TOOLBAR_OPENING = 1
  const TOOLBAR_PUZZLE = 2
  const TOOLBAR_VISUALIZE = 3
  const TOOLBAR_BLINDFOLD = 4


  const toolbarElements = ref([
    { index : TOOLBAR_HOME, label : t("Home") ,disabled : false,collapse:false},
    { index : TOOLBAR_PUZZLE, label : t("Puzzle") , disabled : false,collapse:true},
    { index : TOOLBAR_OPENING, label : t("Opening") , disabled : false,collapse:false},
    { index : TOOLBAR_VISUALIZE, label : t("Visualize") , disabled : false,collapse:false},
    { index : TOOLBAR_BLINDFOLD, label : t("Blindfold") , disabled : false,collapse:false},
  ])

  const styleOneFrame = ref({
     position : "absolute",
     "overflow-y" : "scroll",
     top : "0px",
     left : "100px",
     width: "100px",
     height : "100px"
   })
  
   const content = ref(null)

   const source = ref("https://www.chessvis.com/")
  
  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  updateWidthHeights()
  
  doStartupCheck(false)
  
  watch(() => windowSizeStore.getWindowSize, () => {
      //console.log('*********** window size changes detected')
      windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] }
      //console.log("*** logoff new window size",windowSizeRef.value)
      menuTrigger.value++
      updateWidthHeights()
    })
    
  
  function updateWidthHeights() {
  
    const availableSpace = availableWidthHeight()
    const oneframePositionTop = availableSpace.topIndent
    const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
    const oneframeHeight = availableSpace.height - oneframePositionTop+ availableSpace.topIndent
    const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2
  
    styleOneFrame.value.height = oneframeHeight + "px"
    styleOneFrame.value.width = oneframeWidth + "px"
    styleOneFrame.value.top = oneframePositionTop + "px"
    styleOneFrame.value.left = oneframePositionLeft + "px"
  }
  

  onMounted(()=>{
 })

 const openTOSModal = async () => {
    const modal = await modalController.create({
      component: ModalTOS,
      componentProps: {
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

 function displayTOS() {
    openTOSModal()
  }

  function scrollToId(id) {
    const yOffset = document.getElementById(id).offsetTop;
    content.value.$el.scrollToPoint(0,yOffset -100 ,200)
  }

  function toolbarClick(index) {
    var yOffset = 0
    switch (index) {
      case TOOLBAR_HOME :
        scrollToId("home")
        break
      case TOOLBAR_OPENING :
        scrollToId("opening")
        break
      case TOOLBAR_PUZZLE :
        scrollToId("puzzles")
        break
      case TOOLBAR_VISUALIZE :
        scrollToId("visualize")
        break   
      case TOOLBAR_BLINDFOLD :
        scrollToId("blindfold")
        break
    }
    //menuTrigger.value++
  }

  function getMobileVersion(platform) {
    var urlDestination = ""
    switch (platform) {
      case "ios" :
        urlDestination = "https://itunes.apple.com/us/app/chessvis/id1229226444"
        break
      case "google" :
        urlDestination = "https://play.google.com/store/apps/details?id=com.conceptual.chessvis"
        break
    }
    window.open(urlDestination, '_blank');
  }

/* 

 <h1><span>Chessvis</span> can make you a better chess player</h1>
    
            <h2>Puzzle visualization, opening preparation, blindfold play and other unique visualization tools</h2>
              <a href="https://play.google.com/store/apps/details?id=com.conceptual.chessvis">Google Play</a>
              <a href="https://itunes.apple.com/us/app/chessvis/id1229226444">App Store</a>

*/

  </script>
  
  <style scoped>
  
  .item{
    margin:10px auto;
  }
  
  .percent-50 {
    width : 50%;
    height : 50%;
  }
  .button-center {
    text-align : center;
  }
  .text-center {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
  }

  .puzzle-screenshot {
    height:600px;
    display: block;
  margin-left: auto;
  margin-right: auto;
  }

  .opening-screenshot {
    width:600px;
    display: block;
  margin-left: auto;
  margin-right: auto;
  }

  .chess-image {
	display: block;
  width: 400px;
  margin-left: auto;
  margin-right: auto;
}
  </style>
